module.exports = __webpack_public_path__ + "static/img/no-dist.9879c7cc.png";